import { useEffect, useRef } from 'react';

export default function Cursor(){
  const dot  = useRef(null);
  const ring = useRef(null);
  const pos  = useRef({x:0,y:0});
  const cur  = useRef({x:0,y:0});
  const raf  = useRef(null);

  useEffect(()=>{
    if(window.innerWidth < 1024) return;
    const move = e=>{
      pos.current = {x:e.clientX,y:e.clientY};
      if(dot.current) dot.current.style.transform=`translate(${e.clientX}px,${e.clientY}px)`;
    };
    const tick = ()=>{
      cur.current.x += (pos.current.x - cur.current.x)*0.13;
      cur.current.y += (pos.current.y - cur.current.y)*0.13;
      if(ring.current) ring.current.style.transform=`translate(${cur.current.x}px,${cur.current.y}px)`;
      raf.current = requestAnimationFrame(tick);
    };
    const enter = ()=>{ dot.current?.classList.add('big'); ring.current?.classList.add('big'); };
    const leave = ()=>{ dot.current?.classList.remove('big'); ring.current?.classList.remove('big'); };
    document.addEventListener('mousemove',move);
    document.querySelectorAll('a,button,[data-cursor]').forEach(el=>{ el.addEventListener('mouseenter',enter); el.addEventListener('mouseleave',leave); });
    raf.current = requestAnimationFrame(tick);
    return ()=>{ document.removeEventListener('mousemove',move); cancelAnimationFrame(raf.current); };
  },[]);

  return <>
    <div ref={dot}  id="cursor"/>
    <div ref={ring} id="cursor-ring"/>
  </>;
}